import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { Register } from '@app/utils/type-registry';
import { TextareaFieldInput, TextareaFieldOutput } from '@trackback/widgets';
import { BaseFormControlWidgetComponent } from '../base-form-control-widget.component';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { WidgetsState } from '@app/state/widgets/widgets.state';

@Register('TextareaField')
@Component({
  selector: 'tb-textarea-field',
  templateUrl: './textarea-field.component.html',
  styleUrls: ['./textarea-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    AsyncPipe,
    ParsePipe,
    DynamicWidgetDirective,
  ],
})
export class TextareaFieldComponent extends BaseFormControlWidgetComponent<
  TextareaFieldInput,
  TextareaFieldOutput
> {
  /**
   * @see {@link https://ux.stackexchange.com/questions/95336/how-long-should-the-debounce-timeout-be}
   */
  defaultDebounceTime() {
    return 500;
  }

  async onCtrlEnter() {
    if (
      this.input.enterAction &&
      !this._formControl.disabled &&
      !this._store.selectSnapshot(WidgetsState.getWidgetOutput(this.id))
        .actionPending
    ) {
      await this.updateOutput({ actionPending: true }, false);
      await this.dispatchActionsPromise(this.input.enterAction).finally(() =>
        this.updateOutput({ actionPending: false }, false)
      );
    }
  }
}
